export const MANIFEST = {
  name: 'transcript_create',
  description: `Create a new Transcript entity for a voice recording or interview.

**WHEN TO USE:** user asks to create a transcript, add a recording, or log a voice note
**EXAMPLES:**
{ "name": "Board Meeting Notes", "recordedAt": "2026-04-28T10:00:00Z" }
**RETURNS:** entityId and name of the created transcript`,
  inputSchema: {
    type: 'object' as const,
    properties: {
      name: { type: 'string', description: 'Title of the transcript' },
      recordedAt: { type: 'string', description: 'ISO 8601 recording timestamp' },
      source: { type: 'string', enum: ['manual', 'plaud', 'demo'], description: 'Ingestion source' },
      audioUrl: { type: 'string', description: 'URL to the audio file (optional)' },
      audioDurationMs: { type: 'number', description: 'Audio duration in milliseconds' },
      summary: { type: 'string', description: 'Short summary of the recording content' },
      groupIds: {
        type: 'array',
        items: { type: 'string' },
        description: 'Folder/group IDs to add this transcript to',
      },
    },
    required: ['name'],
  },
} as const;
